import { render, staticRenderFns } from "./project-portfolio-table.vue?vue&type=template&id=29ac6440"
import script from "./project-portfolio-table.ts?vue&type=script&lang=ts&external"
export * from "./project-portfolio-table.ts?vue&type=script&lang=ts&external"
import style0 from "./project-portfolio-table.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ac6440')) {
      api.createRecord('29ac6440', component.options)
    } else {
      api.reload('29ac6440', component.options)
    }
    module.hot.accept("./project-portfolio-table.vue?vue&type=template&id=29ac6440", function () {
      api.rerender('29ac6440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-portfolio/project-portfolio-table/project-portfolio-table.vue"
export default component.exports